<template>
  <div class="block bg-white d-flex flex-column align-items-end">
    <div class="common-modal-header date-modal-header d-flex flex-column align-items-start">
      <div class="default-column-name">
        <span class="default-column-title"> {{columnName}} </span>
      </div>
      <div v-if="!disableChangeColumnName" class="editLabel d-flex flex-row align-items-center" @click="onEditLabelHeader">
        <div class="optionEditLabel">
          <i class="material-icons material-icons-outlined icon_edit">
            edit
          </i>
          <span class="text">表示名を変更</span>
        </div>
      </div>
      <div v-if="!disableChangeColumnName" class="line"></div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 1 },
          'sortByAsc d-flex flex-row align-items-center'
        ]"
        @click="onSortByAsc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_upward">
            arrow_upward
          </i>
          <span class="text">A to Zで並べ替え</span>
        </div>
      </div>
      <div
        v-if="!hideSortOrder"
        :class="[
          { active: this.form.sortBy == 2 },
          'sortByDesc d-flex flex-row align-items-center'
        ]"
        @click="onSortByDesc"
      >
        <div class="optionSort">
          <i class="material-icons material-icons-outlined arrow_downward">
            arrow_downward
          </i>
          <span class="text">Z to Aで並べ替え</span>
        </div>
      </div>
    </div>
    <div v-if="!hideSortOrder" class="line"></div>
    <div class="date-modal-body d-flex flex-row align-items-center">
      <date-picker
        v-model="form.selectedDateFrom"
        format="YYYY-MM-DD"
        value-type="format"
        :editable="false"
        class="dialogDateCalendar"
        ref="datepicker"
        @open="onOpen('datepicker-from')"
        @close="onClose('datepicker-from')"
        @input="onInput">
      </date-picker>
      <label class="iconBetween">&#126;</label>
      <date-picker
        v-model="form.selectedDateTo"
        format="YYYY-MM-DD"
        value-type="format"
        :editable="false"
        class="dialogDateCalendar"
        ref="datepicker"
        @open="onOpen('datepicker-to')"
        @close="onClose('datepicker-to')"
        @input="onInput">
      </date-picker>
    </div>
    <div
      class="
        date-modal-footer
        d-flex
        flex-row
        align-items-center
        justify-content-center
      "
    >
      <b-button variant="link" @click.prevent="onReset" class="btnReset">
        クリア
      </b-button>
      <b-button variant="info" @click.prevent="onSubmit" class="btnSubmit">
        OK
      </b-button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
const SORT_ASC_MODE = 1
const SORT_DESC_MODE = 2
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      form: {
        isItemNo: this.isItemNo,
        sortBy: -1,
        selectedDateFrom: null,
        selectedDateTo: null
      },
      isDatePickerOpen: false,
      idDatePicker: '',
      columnName: this.defaultItemName
    }
  },
  props: ['isItemNo', 'queryPrameterValue', 'defaultItemName', 'disableChangeColumnName', 'hideSortOrder'],
  watch: {
    isItemNo: {
      handler: function (newValue, oldValue) {
        this.form.isItemNo = newValue
      }
    },
    queryPrameterValue: {
      handler: function (newValue, oldValue) {
        if (newValue[`before_${this.form.isItemNo}`] || newValue[`after_${this.form.isItemNo}`]) {
          this.form.selectedDateFrom = newValue[`before_${this.form.isItemNo}`]
          this.form.selectedDateTo = newValue[`after_${this.form.isItemNo}`]
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * ドロップダウンを非表示にした後に値をリセットする
     */
    resetValueComponent() {
      this.form.selectedDateFrom = this.queryPrameterValue[`before_${this.form.isItemNo}`]
      this.form.selectedDateTo = this.queryPrameterValue[`after_${this.form.isItemNo}`]
    },
    /**
     * ドロップダウン表示前に値を設定
     * @param {object} sort ソートが必要な状態
     * @param {string} isItemNo 列をフィルタリングまたはソートする必要があります
     */
    initValueComponent(sort, isItemNo) {
      this.form.selectedDateFrom = this.queryPrameterValue[`before_${this.form.isItemNo}`]
      this.form.selectedDateTo = this.queryPrameterValue[`after_${this.form.isItemNo}`]
      if (sort.propetyName === isItemNo) {
        this.form.sortBy = sort.order
      } else {
        this.form.sortBy = -1
      }
    },
    onSortByAsc() {
      this.form.sortBy = this.toggleSort(SORT_ASC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    onSortByDesc() {
      this.form.sortBy = this.toggleSort(SORT_DESC_MODE)
      this.$emit('on-sort', {order: this.form.sortBy, propetyName: this.getPropertyNameBySort(this.form.sortBy)})
    },
    /**
     * ユーザーが送信をクリックした後に値を発行する
     */
    onSubmit() {
      this.queryPrameterValue[`before_${this.form.isItemNo}`] = this.form.selectedDateFrom ? this.form.selectedDateFrom : null
      this.queryPrameterValue[`after_${this.form.isItemNo}`] = this.form.selectedDateTo ? this.form.selectedDateTo : null
      this.$emit('on-submit', this.queryPrameterValue)
    },
    onEditLabelHeader() {
      this.$emit('allow-edit-label')
    },
    /**
     * ユーザーがクリアボタンをクリックした後に値をリセットする
     */
    onReset() {
      this.form.selectedDateFrom = null
      this.form.selectedDateTo = null
    },
    toggleSort(value) {
      if (this.form.sortBy !== value) {
        return value
      }
      return null
    },
    getPropertyNameBySort(sortBy) {
      return sortBy ? this.form.isItemNo : null
    },
    /**
     * カレンダーが開いた後に送信
     *  @param {string} id 要素の日付ピッカーの ID
     */
    onOpen(id) {
      this.idDatePicker = id
      this.isDatePickerOpen = true
      this.$emit('open-datepicker')
    },
    /**
     * カレンダー終了後に発行
     * @param {string} id 要素の日付ピッカーの ID
     */
    onClose(id) {
      // 開いている日付ピッカーの ID が閉じた日付ピッカーの ID である場合、isDatePickerOpen 変数は false にリセットされます。
      this.isDatePickerOpen = !(this.idDatePicker === id)
      this.$emit('close-datepicker', this.isDatePickerOpen)
    },
    /**
     * 値が変更された後に放出される
     */
    onInput() {
      this.$emit('onInput')
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  padding: 0;
  width: 280px;
  height: auto;
  padding: 4px 1px 4px 8px;
  cursor: default;
}
.date-modal-header {
  margin: 0 !important;
  left: 10px;
  top: 4px;
}
.line {
  width: 272px;
  height: 1px;
  left: 8px;
  top: 92px;
  margin: 8px 0;
  background: $line_gray;
}
.date-modal-body {
  padding: 8px 8px 8px 4px;
  width: 272px;
  min-height: 54px;
}
.date-modal-footer {
  padding: 3px 8px;
  width: 272px;
  height: 58px;
  .btnReset {
    padding-right: 35px;
    font-weight: normal !important;
    @include responsive-fs(12);
    color: #4e66a6 !important;
    text-decoration: none;
  }
}
.arrow_downward, .arrow_upward {
  @include responsive-fs(15);
}
.icon_edit {
  @include responsive-fs(14);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DateFilterSortModal.vue